import { createRoot } from 'react-dom/client';
import './index.css';

// @ts-ignore
import App from './components/App.jsx';

console.log('App:', App);
console.log('typeof:', typeof App);

const container = document.getElementById('editorRoot')!;
const root = createRoot(container);
root.render(<App/>);